import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

// import useUserRole from '../../hooks/useUserRole';

export default function HomePage() {
  const navigate = useNavigate();

  // const { isOwner, isSuperAdmin } = useUserRole();

  useEffect(() => {
    navigate('/loan-files', { replace: true });
  }, [navigate]);

  return null;
}
